import Vue from 'vue';
import Component from 'vue-class-component';
import { minLength, required, sameAs } from 'vuelidate/lib/validators';
import { Prop } from 'vue-property-decorator';
import * as api from 'core/api/SupportService';
import { SbpRefundInfo, SubmitSbpRefundRequest } from 'core/api';
import { G2S } from 'core/g2s';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

export interface AccountContactsComponentModel {
    phone: string;
    selectedBankId: number | null;
    isTermsAccepted: boolean;
}

enum ViewedFrom {
    unknown = 0,
    sms = 1,
    email = 2
}

@WithRender
@Component({
    validations: {
        model: {
            phone: { required, minLength: minLength(5) },
            selectedBankId: { required },
            isTermsAccepted: { required, sameAs: sameAs(() => true) }
        }
    }
})
export default class RefundApplicationComponent extends Vue {
    @Prop()
    publicId: string;
    
    model: AccountContactsComponentModel = {
        phone: '',
        selectedBankId: null,
        isTermsAccepted: false
    };
    
    view = 'loading';
    viewedFrom = 'unknown';
    errorText = '';
    refundInfo: SbpRefundInfo | null = null;

    mounted() {
        if (this.$route.query.viewedFrom) {
            this.viewedFrom = this.$route.query.viewedFrom as string;    
        }
        
        this.getRefundData();
    }

    getRefundData() {
        this.view = 'loading';

        new api.SupportService().getRefundInfo(this.publicId).then(
            (result: SbpRefundInfo) => {
                this.refundInfo = result;

                if (result.message) {
                    this.errorText = result.message;
                    this.view = 'error';
                    return;
                }

                this.view = 'view';
            },
            (error) => {
                this.errorText = '';
                this.view = 'error';
                
                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }
    
    onSubmit() {
        const bankName = this.refundInfo?.banks.find(
            (bank) => bank.id === this.model.selectedBankId)?.name;
        
        const request = {
            publicId: this.publicId,
            viewedFrom: ViewedFrom[this.viewedFrom.toLowerCase()],
            phoneNumber: this.model.phone,
            refundBankId: this.model.selectedBankId,
            clientIp: G2S.config.clientDevice.ipAddress,
            refundBankName: bankName
        } as SubmitSbpRefundRequest;
        
        new api.SupportService().submitRefundInfo(request).then(
            (result) => {
                if (result.message) {
                    this.errorText = result.message;
                    this.view = 'error';
                    
                    return;
                }

                this.view = 'success';
            },
            (error) => {
                this.errorText = '';
                this.view = 'error';
                
                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }
}
